<template>
  <div
    class="pega-count-moji"
    @click.stop
    @select.stop
  >
    <div data-test="name">
      {{ name }}
    </div>
    <div data-test="length">
      {{ countTarget.value.length }}/{{ countTarget.max }}文字
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    countTarget: {
      type: Object,
      required: true
    }
  }
}
</script>
